export default "__VITE_ASSET__ujOgEWbs__"